import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { LAUNCHER_CAMPAIGNS_QUERY_KEY } from '../../_shared/launcher-campaign-schema';
import { fetchCampaigns } from '../api-client';
import type { Campaign } from '../components/types';

export function useLauncherCampaigns() {
  const { apiFetch } = useApi();

  // The key and the fetcher both come from
  // `_shared/launcher-campaign-schema.ts` (api-client's `fetchCampaigns` is a
  // thin delegate) — four apps share this cache entry, so exactly one parsed
  // shape may ever be written to it. See that module's header (QA round 8, U2)
  // and `_shared/__tests__/launcher-campaigns-query-key.test.ts`.
  const query = useQuery<Campaign[]>({
    queryKey: LAUNCHER_CAMPAIGNS_QUERY_KEY,
    queryFn: () => fetchCampaigns(apiFetch),
    staleTime: Infinity,
  });

  return {
    campaigns: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  } as const;
}
